import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
// import Moment from 'react-moment';
import { BigCalendar, Calendar, momentLocalizer } from 'react-big-calendar'
import moment from "moment";
import 'moment/locale/pl';

import "react-big-calendar/lib/css/react-big-calendar.css";
// import { addClient, listClients } from '../actions/client';
import { SelectPicker } from 'rsuite';
// import ClientAdd from './ClientAdd';
require('globalize/lib/cultures/globalize.culture.pl')

var z = 0


class WorkCalendar extends React.Component {

  constructor() {
      super();
      this.state = {
          name: '',
          errors: {},
          list: []
      }
    //   this.handleInputChange = this.handleInputChange.bind(this);
    //   this.handleSubmit = this.handleSubmit.bind(this);
    //   this.fetchApi = this.fetchApi.bind(this);
  }

//   fetchApi() {
//     let currentorg = localStorage.getItem('currentorg');
//     this.props.listClients(currentorg, 'name', this.props.history);
//   }

  componentDidMount() {
    // this.fetchApi();
    // this.timeout = setInterval(() => {
    //   this.fetchApi();
    // }, 10000)
  }


  componentWillUnmount() {
    // clearTimeout(this.timeout);
  }

//   handleInputChange(n, v ) {
//       this.setState({
//           [n]: v
//       })
//   }

//   handleSubmit(e) {
//       e.preventDefault();
//       const organization = {
//           name: this.state.name,
//           organization: localStorage.getItem('currentorg')
//       }
//       this.props.addClient(organization, this.props.history);
//   }

    render() {
        const { errors } = this.state;
        const localizer = momentLocalizer(moment)
        // moment.locale("fr");
        const myEventsList=[
        {
            id: 1,
            title: 'Long Event',
            start: new Date(2025, 3, 20),
            end: new Date(2025, 3, 20),
            },
            {
            id: 2,
            title: 'DTS STARTS',
            start: new Date(2025, 3, 20, 0, 0, 0),
            end: new Date(2025, 3, 20, 0, 0, 0),
            },
        ]
        const cultures = ['en', 'pl']
        const lang = {
            en: null,
            pl: {
                week: 'Tydzień',
                work_week: 'Tydzień roboczy',
                day: 'Dzień',
                month: 'Miesiąc',
                previous: 'Poprzedni',
                next: 'Następny',
                today: 'Dzisiaj',
                agenda: 'Agenda',
                showMore: (total) => `+${total} miesięcy`,
            }
        }

    //   console.log(this.props);
      return (
        <div className="component calendar">
            <h1>Kalendarz</h1>
            <div className="component-header">

            </div>
            <div className="component-content">
            <Calendar
                localizer={localizer}
                events={myEventsList}
                startAccessor="start"
                endAccessor="end"
                messages={lang.pl}
                culture={'pl'}
                style={{ height: 500 }}
                />
            </div>
        </div>
      );
    }
}

// Clients.propTypes = {
//     addClient: PropTypes.func.isRequired,
//     listClients: PropTypes.func.isRequired
// };

const mapStateToProps = state => ({
    // clients: state.clients,
    // auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps)(withRouter(WorkCalendar))
